(function () {
  // Idempotency guard. Shopify increment counters are scoped to the layout,
  // template, or section file that creates them, not to the page, so two
  // sections on one page can each emit this script tag. Without this guard the
  // second copy binds a duplicate submit listener and a single click adds to
  // cart twice.
  if (window.MBBuyCardLoaded) return;
  window.MBBuyCardLoaded = true;

  function cartAddUrl() {
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (url.indexOf('.js') === -1) {
      url = url.replace(/\/?$/, '') + '.js';
    }
    return url;
  }

  function setStatus(card, message) {
    var status = card.querySelector('[data-mb-buy-status]');
    if (status) status.textContent = message || '';
  }

  function syncMinusState(card) {
    var qty = card.querySelector('.mb-buy-card__qty');
    var minus = card.querySelector('[data-mb-buy-qty-btn="minus"]');
    if (!qty || !minus) return;
    var value = parseInt(qty.value, 10);
    if (isNaN(value) || value < 1) value = 1;
    minus.disabled = value <= 1;
  }

  function updateCartBubble(itemCount) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;

    var bubble = icon.querySelector('.cart-count-bubble');
    if (itemCount > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        icon.appendChild(bubble);
      }
      var visible = itemCount < 100 ? '<span aria-hidden="true">' + itemCount + '</span>' : '';
      bubble.innerHTML =
        visible +
        '<span class="visually-hidden">' +
        itemCount +
        (itemCount === 1 ? ' item in cart' : ' items in cart') +
        '</span>';
    } else if (bubble) {
      bubble.remove();
    }
  }

  // Append one add event to the hidden _mb_adds cart attribute. The attribute
  // rides onto the order invisibly (the theme renders only the cart note, and
  // checkout does not show attributes), so attribution survives without line
  // properties, which is what lets identical variants merge into one line.
  // Format: source:path:variantId:qty entries joined by |, oldest dropped
  // beyond ~900 chars. Fire-and-forget; tracking must never break the cart.
  function logAddEvent(source, pagePath, variantId, quantity) {
    try {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var entry = source + ':' + pagePath + ':' + variantId + ':' + quantity;
          var log = (cart.attributes && cart.attributes._mb_adds) || '';
          log = log ? log + '|' + entry : entry;
          while (log.length > 900 && log.indexOf('|') !== -1) {
            log = log.slice(log.indexOf('|') + 1);
          }
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { _mb_adds: log } })
          });
        })
        .catch(function () {});
    } catch (e) {}
  }

  function refreshCartBubble() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          updateCartBubble(cart.item_count);
        }
      });
  }

  function applySelectState(card, select) {
    var option = select.options[select.selectedIndex];
    if (!option) return;

    var price = card.querySelector('[data-mb-buy-price]');
    if (price && option.getAttribute('data-price')) {
      price.textContent = option.getAttribute('data-price');
    }

    // Compare-at (strike-through) price. Guarded because cached markup from
    // before this feature shipped won't have the element at all.
    var comparePrice = option.getAttribute('data-compare-price') || '';
    var compare = card.querySelector('[data-mb-buy-compare]');
    var compareLabel = card.querySelector('[data-mb-buy-compare-label]');
    var priceWrap = card.querySelector('.mb-buy-card__price');
    if (compare) {
      if (comparePrice) {
        compare.textContent = comparePrice;
        compare.hidden = false;
        if (compareLabel) compareLabel.hidden = false;
      } else {
        compare.textContent = '';
        compare.hidden = true;
        if (compareLabel) compareLabel.hidden = true;
      }
    }
    if (priceWrap) {
      priceWrap.classList.toggle('mb-buy-card__price--sale', !!comparePrice);
    }

    var link = card.querySelector('[data-mb-buy-link]');
    var productUrl = card.getAttribute('data-product-url') || '';
    if (link && productUrl) {
      link.href = productUrl + '?variant=' + encodeURIComponent(option.value);
    }

    var image = card.querySelector('.mb-buy-card__image');
    var imageUrl = option.getAttribute('data-image');
    if (image && imageUrl) {
      image.src = imageUrl;
      image.removeAttribute('srcset');
    }

    var available = option.getAttribute('data-available') === 'true';
    var actions = card.querySelector('[data-mb-buy-actions]');
    var notify = card.querySelector('[data-mb-buy-notify]');
    if (actions) actions.hidden = !available;
    if (notify) notify.hidden = available;
    card.classList.toggle('mb-buy-card--sold-out', !available);
  }

  function initCard(card) {
    var form = card.querySelector('[data-mb-buy-form]');
    var select = card.querySelector('[data-mb-buy-select]');
    var qty = card.querySelector('.mb-buy-card__qty');
    var submit = card.querySelector('[data-mb-buy-submit]');

    card.querySelectorAll('[data-mb-buy-qty-btn]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!qty) return;
        if (button.getAttribute('data-mb-buy-qty-btn') === 'plus') {
          qty.stepUp();
        } else {
          qty.stepDown();
        }
        qty.dispatchEvent(new Event('change', { bubbles: true }));
        syncMinusState(card);
      });
    });

    if (qty) {
      qty.addEventListener('change', function () {
        var value = parseInt(qty.value, 10);
        if (isNaN(value) || value < 1) qty.value = '1';
        syncMinusState(card);
      });
      syncMinusState(card);
    }

    if (select) {
      select.addEventListener('change', function () {
        applySelectState(card, select);
      });
    }

    if (!form) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (submit && submit.getAttribute('aria-disabled') === 'true') return;

      var idField = form.querySelector('[name="id"]');
      var qtyField = form.querySelector('[name="quantity"]');
      var id = idField ? idField.value : '';
      var quantity = qtyField ? parseInt(qtyField.value, 10) : 1;
      if (!id) {
        setStatus(card, 'Could not add to cart');
        return;
      }
      if (isNaN(quantity) || quantity < 1) quantity = 1;

      var originalLabel = submit ? submit.textContent : '';
      if (submit) {
        submit.setAttribute('aria-disabled', 'true');
        submit.textContent = 'Adding';
      }
      form.setAttribute('aria-busy', 'true');
      setStatus(card, '');

      // Attribution: which surface this add came from. Stored as a hidden line
      // item property on the order itself, so Shopify order data is the ground
      // truth for upsell attach analysis regardless of any analytics tool.
      var source = 'buy-shortcode';
      if (card.closest('.product-upsell-row')) {
        source = 'upsell-row';
      } else if (card.closest('.mb-product-tabs, .product__accordion, .accordion')) {
        // Buttons inside the product tabs or accordions: instructions,
        // contents, compatibility. These live on product pages but sell
        // from the guide content, so they get their own bucket.
        source = 'product-tab';
      }
      // Which page the add happened on, so shortcode adds attribute to the
      // specific article or page that sold them. Path only, no query string,
      // capped so a pathological URL cannot bloat the order.
      var pagePath = (location.pathname || '').slice(0, 120);

      // First-touch merge: if this variant already has a line in the cart,
      // post the add with THAT line's properties (not a fresh tag) so
      // Shopify merges the quantities into one line instead of splitting
      // into a second, untagged line. Only untagged (new) lines get the
      // attribution properties. logAddEvent below still records the TRUE
      // source of this click either way, so attribution never depends on
      // which properties actually got posted.
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var freshProperties = { _mb_source: source, _mb_page: pagePath };
          var items = (cart && cart.items) || [];
          for (var i = 0; i < items.length; i++) {
            if (Number(items[i].variant_id) === Number(id)) {
              var existing = items[i].properties;
              // null (propertyless line) normalizes to undefined so it is
              // omitted below, matching the existing line exactly.
              return existing === null || existing === undefined ? undefined : existing;
            }
          }
          return freshProperties;
        })
        .catch(function () {
          // Could not read the cart; never block the add, just tag it fresh.
          return { _mb_source: source, _mb_page: pagePath };
        })
        .then(function (properties) {
          var item = { id: Number(id), quantity: quantity };
          if (properties !== undefined) item.properties = properties;
          return fetch(cartAddUrl(), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items: [item] })
          });
        })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          var data = result.data || {};
          if (!result.ok || data.status) {
            setStatus(card, data.description || data.message || 'Could not add to cart');
            return;
          }
          setStatus(card, 'Added to cart');
          refreshCartBubble();
          logAddEvent(source, pagePath, id, quantity);

          // Secondary signals, each guarded so a missing tool costs nothing.
          try {
            var priceText = card.querySelector('[data-mb-buy-price]');
            var evt = 'buy_shortcode_add_to_cart';
            if (source === 'upsell-row') evt = 'upsell_row_add_to_cart';
            else if (source === 'product-tab') evt = 'product_tab_add_to_cart';
            if (typeof window.gtag === 'function') {
              window.gtag('event', evt, { item_id: String(id), quantity: quantity, page_path: pagePath });
            } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
              window.dataLayer.push({ event: evt, item_id: String(id), quantity: quantity, page_path: pagePath });
            }
            if (typeof window.clarity === 'function') {
              window.clarity('event', evt);
            }
          } catch (e) { /* analytics must never break the cart */ }
        })
        .catch(function () {
          HTMLFormElement.prototype.submit.call(form);
        })
        .then(function () {
          if (submit) {
            submit.removeAttribute('aria-disabled');
            submit.textContent = originalLabel;
          }
          form.removeAttribute('aria-busy');
        });
    });
  }

  // The ready flag is what makes rescanning safe: a card is only ever bound once,
  // however many times scan runs over it.
  function scan(root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    var found = scope.querySelectorAll('[data-mb-buy-card]');
    Array.prototype.forEach.call(found, function (card) {
      if (card.getAttribute('data-mb-buy-card-ready')) return;
      card.setAttribute('data-mb-buy-card-ready', '1');
      initCard(card);
    });
  }

  scan(document);

  // A section re-render swaps in fresh card markup that carries no listeners, and
  // the re-emitted script tag cannot rebind them because the guard above stops the
  // second copy. Rescanning the replaced section is what keeps those buttons alive.
  // This fires in the theme editor whenever a section is edited.
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();

